package ru.villawonka.app.presentation.screens.searchFilter.compose.view

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.Row
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.components.AppFilledChip
import ru.villawonka.app.presentation.design.extensions.AppSpacer
import ru.villawonka.app.presentation.design.theme.AppTextStyles
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary
import ru.villawonka.app.presentation.screens.searchFilter.compose.SearchFilterCallbacks
import ru.villawonka.app.presentation.screens.searchFilter.model.ChipUIModel
import ru.villawonka.app.resources.AppResources

@Composable
fun ColumnScope.BedroomsCardView(
    chips: List<ChipUIModel<String>>,
    callbacks: SearchFilterCallbacks
) {
    CardView {
        Text(
            text = AppResources.strings.searchFilterRoomsCountLabel,
            style = AppTextStyles.bodyMediumRegular,
            color = MaterialTheme.colors.onSurfacePrimary
        )
        AppSpacer(12.dp)
        Row {
            chips.forEach {
                AppFilledChip(
                    text = it.text,
                    focused = it.selected,
                    onClick = { callbacks.onRoomsCountChipClick(it) }
                )
                AppSpacer(12.dp)
            }
        }
    }
}